export const authoriseStatus = {
  Pending: 1,
  Done: 2,
  Rejected: 3,
  Removed:4
};

export default authoriseStatus;
